import type { LogSearchDuration } from '@/utils/coralogixLinkGenerator'
import { generateLogSearchUrl } from '@/utils/coralogixLinkGenerator'

/**
 * Builds a Coralogix log-search URL scoped to a single controller.
 *
 * Controller logs are keyed on the controller's equipment number, so without one there is no
 * filter to search by. Returning null lets callers hide the link entirely rather than offer a
 * query that matches nothing.
 */
export function makeControllerLogSearchUrl(
  equipmentNumber: number | null | undefined,
  duration: LogSearchDuration,
  filters: string[] = [],
): string | null {
  if (equipmentNumber === null || equipmentNumber === undefined) {
    return null
  }

  return generateLogSearchUrl([...filters, `equipmentNumber == '${equipmentNumber}'`], duration)
}
